import React from 'react';

export const PlayRecordingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18.62" height="23.698" viewBox="0 0 18.62 23.698">
    <path id="ic_play_arrow_24px" d="M8,5V25.965L24.473,15.483Z" transform="translate(-7.25 -3.634)" fill="none"
          stroke="#FAFAFA" strokeLinecap="round" strokeWidth="1.5"/>
  </svg>
);
